export enum RateTypes {
  GrnPerLiter = 1,
  Percent = 2,
}
